import styled, { keyframes } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const Wrapper = styled.div`
  text-align: center;
  color: white;
`;

export const Title = styled.div`
  opacity: 0.6;
  ${typography['headline2']};
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const Amount = styled.div`
  font-size: 64px;
  font-weight: 700;
  display: inline-flex;
  justify-content: center;
  font-family: 'Work Sans', sans-serif;
  @media (${device.mobile}) {
    font-size: 56px;
    line-height: 100%;
    letter-spacing: 3%;
  }

  @media (min-width: 360px) and (max-width: 372px) {
    font-size: 53px;
  }
`;

export const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
`;

export const Digit = styled.span<{ animate: boolean }>`
  display: inline-block;
  min-width: 1ch;
  animation: ${({ animate }) => (animate ? slideUp : 'none')} 0.4s ease;
  transition: transform 0.2s;
`;
